/**
 * ============================================================
 * Français
 * ============================================================
 *
 * Translators:
 *
 * BakaKiller
 */

import { Monogatari } from './../monogatari';

Monogatari.translation ('Français', {
	'AdvanceHelp': 'Pour avancer dans le jeu, appuyez sur la touche espace ou cliquez',
	'AllowPlayback': 'Click here to allow audio playback',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Enable auto play',
	'AutoPlaySpeed': 'Vitesse de lecture automatique',

	'Back': 'Retour',
	'BackButton': 'Retour',

	'Cancel': 'Annuler',
	'Close': 'Fermer',
	'Confirm': 'Voulez-vous vraiment quitter?',
	'Credits': 'Credits',

	'Delete': 'Delete',
	'DialogLogButton': 'Show the dialog log',

	'FullScreen': 'Plein Écran',

	'Gallery': 'Gallery',

	'Help': 'Aide',
	'Hide': 'Cacher',
	'HideButton': 'Cacher le Texte',

	'iOSAudioWarning': 'Les paramètres audio ne sont pas pris en charge par iOS',

	'KeyboardShortcuts': 'Keyboard Shortcuts',

	'Language': 'Langue',
	'Load': 'Charger',
	'LoadAutoSaveSlots': 'Parties Enregistrées Automatiquement',
	'LoadButton': 'Ouvrir l’écran de Chargement',
	'Loading': 'Chargement',
	'LoadingMessage': 'Veuillez patienter pendant que les fichiers sont chargés',
	'LoadSlots': 'Parties Sauvegardées',
	'LocalStorageWarning': 'Le stockage local n’est pas disponible sur ce navigateur',
	'Log': 'Log',

	'Music': 'Volume de la Musique',

	'NewContent': 'There is new content available, reload the page to get the latest version',
	'NoSavedGames': 'Pas de parties sauvegardées',
	'NoAutoSavedGames': 'Aucune partie enregistrée automatiquement',
	'NoDialogsAvailable': 'No dialogs available. Dialogs will appear here as they show up',

	'OrientationWarning': 'Please rotate your device to play',
	'Overwrite': 'Écraser',

	'QuickButtons': 'Boutons du Menu Rapide',
	'QuickMenu': 'Quick Menu',
	'Quit': 'Quitter',
	'QuitButton': 'Quitter le Jeu',

	'Resolution': 'Résolution',

	'Save': 'Sauvegarder',
	'SaveButton': 'Ouvrir l’écran de Sauvegarde',
	'SaveInSlot': 'Enregistrer à l’emplacement',
	'Settings': 'Préférences',
	'SettingsButton': 'Ouvrir l’écran des Préférences',
	'Show': 'Monter',
	'Skip': 'Skip',
	'SkipButton': 'Enter skip mode',
	'SlotDeletion': 'Êtes-vous sûr de vouloir supprimer cet emplacement ?',
	'SlotOverwrite': 'Êtes vous sûr de vouloir remplacer cet emplacement ?',
	'Sound': 'Volume des Sons',
	'Start': 'Démarrer',
	'Stop': 'Arrêter',

	'TextSpeed': 'Vitesse du Texte',

	'Video': 'Video Volume',
	'Voice': 'Volume de la Voix',

	'Windowed': 'Fenêtré'
});